import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LoginService {

    constructor() {
        this.httpClient = new HttpClient()
        this.url = process.env.REACT_APP_KECLOACK_URL
    }

    loginUser(userName, password) {
        let formData = new URLSearchParams()
        formData.append("username", userName)
        formData.append("password", password)
        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", process.env.REACT_APP_CLIENT_SECRET)
        formData.append("grant_type", "password")

        return new Promise((resolve, reject) => {

            /*resolve({
                data: {
                    refresh_token: "refresh_token",
                    access_token: "access_token"
                }
            })*/

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(response => {
                    resolve(response)
                }).catch(reason => {
                reject(reason)
            })


        })

    }


    getUserTokenByRefreshToken(refreshToken) {

        let formData = new URLSearchParams()
        formData.append("refresh_token", refreshToken)
        formData.append("client_id", this.httpClient.getClientId())
        formData.append("client_secret", this.httpClient.getClientSecret())
        formData.append("grant_type", "refresh_token")

        return new Promise((resolve, reject) => {

            /*resolve({
                data: {
                    refresh_token: "refresh_token",
                    access_token: "access_token"
                }
            })*/

            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }

            axios.post(
                this.url,
                formData,
                config)
                .then(response => {
                    resolve(response)
                }).catch(reason => {
                reject(reason)
            })
        })

    }

    sendVerificationCode(username, password) {

        let formData = new URLSearchParams()
        formData.append("username", username)
        formData.append("password", password)

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }

        return new Promise((resolve, reject) => {
            axios.post(
                process.env.REACT_APP_BASE_URL + "admins/two-factors/otp/sms",
                formData,
                config
            ).then(resolve).catch(reject)
        })
    }
}